export default "__VITE_ASSET__C2tCmoX6__"